

import { STORAGE_CHANGE_INFO } from '@/utils/train-storage'
import { getStorage } from '@/utils/storage'

export default {
  changeOrderInfo: getStorage(STORAGE_CHANGE_INFO) || {}
}
